<template>
  <div
    v-if="showNextEvent"
    :class="$style.eventContainer"
  >
    <ParagraphBody
      bodySize="small"
      :class="$style.eventText"
      data-test-id="NextScheduledEvent__event"
    >
      {{ getText }}
    </ParagraphBody>
  </div>
</template>

<script>
import {
  ItemTypeConsts,
  ModuleConsts,
  StoreModelMap,
  StoreModuleMap,
} from 'client/util/Constants';
import {
  ParagraphBody,
} from '@jumpcloud/ui-components';
import { mapActions, mapState } from 'vuex';
import DateUtil from 'client/util/DateUtil';
import ModalEventBus from 'components/Modal/ModalEventBus';

const { activated, suspended } = ModuleConsts.systemUser.accountStates;

const systemUserCollection = StoreModuleMap[ItemTypeConsts.systemUser];
const systemUserModel = StoreModelMap[ItemTypeConsts.systemUser];

export default {
  name: 'NextScheduledEvent',

  components: {
    ParagraphBody,
  },

  ModalEventBus,

  dateFormat: 'MMM D, YYYY',

  stateMap: new Map([
    [activated, 'Activate'],
    [suspended, 'Suspend'],
  ]),

  computed: {
    ...mapState(systemUserCollection, {
      modifiedItemCount: state => state.features.modifiedItemCount,
    }),

    ...mapState(systemUserModel, ['item', 'scheduledStateChangesForUser']),

    getText() {
      let text = '';
      const events = this.scheduledStateChangesForUser;

      if (events.length) {
        // Get first scheduled event
        const [firstEvent] = events;
        const format = this.$options.dateFormat;

        const eventDate = DateUtil.customFormatDate(firstEvent.scheduledDate, format);

        text = `${this.$options.stateMap.get(firstEvent.state)} on ${eventDate}`;
      }

      return text;
    },

    showNextEvent() {
      return !!this.getText;
    },
  },

  watch: {
    /**
     * The `modifiedItemCount` is updated when a user state change is scheduled. When the count
     * changes, fetch the scheduled changes so that the display is updated if an earlier job is
     * scheduled.
     */
    async modifiedItemCount() {
      await this.updateScheduledChanges();
    },
  },

  mounted() {
    this.updateScheduledChanges();
  },

  methods: {
    ...mapActions(systemUserModel, ['fetchScheduledStateChanges']),

    async updateScheduledChanges() {
      await this.fetchScheduledStateChanges();
    },
  },
};
</script>

<style module>
.eventContainer {
  display: flex;
  justify-content: center;
}

.hr {
  border: 0;
  border-bottom: var(--jc-border-width) solid var(--jc-border-color-medium);
}

.eventText {
  padding-bottom: var(--jc-spacer-small);
}
</style>
